import React from 'react';
import PropTypes from 'prop-types';
import { ValueEditor } from 'react-querybuilder';
import ValidationMessage from '../../../common/components/validator-message/ValidationMessage';
import { getValidationMessage } from '../query-utils/utilsIndex';

/**
 * Custom value editor that wraps the default react-querybuilder ValueEditor
 * and displays a validation message below the input when the rule is invalid.
 */
const ValidatedValueEditor = (props) => {
  const { operator, value, field } = props;

  // Null/notNull operators have no value input — skip validation display
  if (operator === 'null' || operator === 'notNull') {
    return <ValueEditor {...props} />;
  }

  const errorMessage = getValidationMessage({ value, operator });

  return (
    <div className="validated-value-editor" data-testid={`validated-value-editor-${field}`}>
      <ValueEditor {...props} />
      <ValidationMessage error={errorMessage} fieldName={field} />
    </div>
  );
};

ValidatedValueEditor.propTypes = {
  operator: PropTypes.string,
  value: PropTypes.any,
  field: PropTypes.string,
};

export default ValidatedValueEditor;
